import { formatDateTime } from "../../../../utils/formatters";
import React from "react";
import { Plus, Play, Wrench, Truck, Check, CheckCircle2 } from "lucide-react";
import { Card } from "../../../../components/ui/Card";
import { cn } from "../../../../libs/utils";

const stepIcons = {
  created: Plus,
  started: Play,
  rework: Wrench,
  dispatched: Truck,
  completed: CheckCircle2,
};

const formatTimestamp = (date) =>
  date
    ? formatDateTime(date)
    : "Pending";

/**
 * Horizontal step tracker for a batch's production lifecycle. Steps are
 * generic ({ key, label, timestamp, done, skipped }) so this isn't tied to
 * exactly four stages if the workflow changes later.
 */
const ProductionTimeline = ({ steps }) => {
  const visibleSteps = steps.filter((step) => !step.skipped);

  return (
    <Card className="p-5">
      <h2 className="sr-only">Production Timeline</h2>
      <div className="flex items-start">
        {visibleSteps.map((step, index) => {
          const Icon = stepIcons[step.key] || Check;
          const isLast = index === visibleSteps.length - 1;
          const isReworkAlert = step.key === "rework" && step.done;

          return (
            <div key={step.key} className={cn("flex items-center", !isLast && "flex-1")}>
              <div className="flex flex-col items-center gap-1.5">
                <div
                  className={cn(
                    "flex h-5 w-5 items-center justify-center rounded-md",
                    step.done
                      ? isReworkAlert
                        ? "bg-amber-500 text-white"
                        : "bg-brand text-white"
                      : "bg-slate-100 text-slate-400"
                  )}
                >
                  <Icon className="h-3 w-3" />
                </div>
                <div className="text-center">
                  <p className="text-[11px] font-semibold sm:text-xs text-slate-600">{step.label}</p>
                  <p className="text-[11px] text-slate-400">{formatTimestamp(step.timestamp)}</p>
                </div>
              </div>
              {!isLast && (
                <div className={cn("mx-1 mb-7 h-0.5 flex-1", step.done ? "bg-brand" : "bg-slate-200")} />
              )}
            </div>
          );
        })}
      </div>
    </Card>
  );
};

export default ProductionTimeline;
